var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[[_c('Header'),_c('side-bar',[_c('sidebar-link',{attrs:{"to":"/dashboard"}},[_c('md-icon',[_vm._v("home")]),_c('p',[_vm._v(_vm._s(_vm.translate(_vm.locale.home)))])],1)],1),_c('div',{staticClass:"main-panel",staticStyle:{"padding-top":"68px"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Footer')],1)]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1621ca6a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Layout.vue
// module id = null
// module chunks = 